import React, { useEffect, useState } from 'react'
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Rating } from "@progress/kendo-react-inputs";
import { ProgressBar } from '@progress/kendo-react-progressbars';
import { useTranslation } from 'react-i18next';


const RatingsReviews = ({ reviews, data }) => {
    const { comments: commentsArray } = reviews;

    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'allClientsScreen' });

    const sortOptions = [
        t("ratingsReviewsFavourable"),
        t("ratingsReviewsCritical"),
        t("ratingsReviewsRecent")
    ]

    const [selectedSort, setSelectedSort] = useState(sortOptions[2]);
    const [comments, setComments] = useState(commentsArray.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)));

    const [isExpanded, setIsExpanded] = useState(false);

    const maxChars = 250;

    const toggleReadMore = () => {
        setIsExpanded(!isExpanded);
    };


    const handleSortChange = (e) => {
        setSelectedSort(e.target.value);

        let sortedArray = [...comments];

        if (e.target.value === sortOptions[0]) {
            sortedArray.sort((a, b) => b.rankValue - a.rankValue);
        } else if (e.target.value === sortOptions[1]) {
            sortedArray.sort((a, b) => a.rankValue - b.rankValue);
        } else if (e.target.value === sortOptions[2]) {
            sortedArray.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
        }

        setComments(sortedArray);
    }

    const calculatePercentage = (reviews, stars) => {
        const count = reviews.filter(review => review.rankValue === stars).length;
        return (count / reviews.length) * 100;
    };

    const percentage5Stars = calculatePercentage(comments, 5);
    const percentage4Stars = calculatePercentage(comments, 4);
    const percentage3Stars = calculatePercentage(comments, 3);
    const percentage2Stars = calculatePercentage(comments, 2);
    const percentage1Stars = calculatePercentage(comments, 1);

    const percentagePerStar = [{ percentage: percentage5Stars, value: 5 }, { percentage: percentage4Stars, value: 4 }, { percentage: percentage3Stars, value: 3 }, { percentage: percentage2Stars, value: 2 }, { percentage: percentage1Stars, value: 1 }];

    const customItem = (props) => {
        const { selected, showEmptyStars } = props;

        return (
            <span
                className={`k-icon ${selected ? 'k-i-star' : (showEmptyStars ? 'k-i-star-outline' : '')}`}
                style={{ color: selected ? '#FFD700' : (showEmptyStars ? '#D3D3D3' : 'transparent') }}
            />
        );
    };

    useEffect(() => {
        const index = sortOptions.findIndex(option => option === selectedSort);

        if (index !== -1) {
            setSelectedSort(sortOptions[index]);
        } else {
            setSelectedSort(sortOptions[0]);
        }
    }, [t])

    const hasComments = reviews.comments.length > 0;

    return (
        <>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", width: "100%" }}>
                <div className="average-ratingsTotal" >
                    <p style={{ fontSize: "40px", lineHeight: 1, fontWeight: 900 }}>{hasComments ? reviews.rankingResult : 0}</p><span>{t("ratingsReviewsTotal")}</span>
                </div>
                <p style={{ fontWeight: 700 }}>{hasComments ? `${comments.length} ${t("totalRatings")}` : t("withoutRatings")}</p>
            </div>
            <div className="clientsDashboardView-ratingsReviews-starsBar-container">
                <div style={{ display: "grid", gridTemplateColumns: "1fr auto", alignItems: "center", direction: 'rtl', width: "100%", maxWidth: "100%" }}>
                    {percentagePerStar.map(({ percentage, value }) => (
                        <>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <ProgressBar className="progress-bar" labelVisible={false} value={hasComments ? percentage : 0} max={100} animation={true} progressStyle={{ backgroundColor: hasComments ? '#FFD700' : 'transparent', borderRadius: '5px' }} />
                            </div>
                            <div className="rating-stars">
                                <Rating value={value} readonly item={(props) => customItem({ ...props, showEmptyStars: false })} style={{ lineHeight: 1 }} />
                            </div>
                        </>
                    ))}
                </div>
            </div>
            <div style={{ display: "flex", gridColumn: "span 2", justifySelf: "end", lineHeight: "1", cursor: hasComments ? "default" : "not-allowed" }}>
                <DropDownList disabled={!hasComments} data={sortOptions} value={selectedSort} onChange={hasComments ? (e) => handleSortChange(e) : null} style={{ backgroundColor: "transparent", border: "none", lineHeight: 1, maxWidth: "100%", boxShadow: "none" }} />
            </div>


            {hasComments > 0 ?

                comments.map(comment => {
                    const date = new Date(comment.createdDate);
                    const formattedDate = date.toLocaleDateString(i18n.language, { year: 'numeric', month: '2-digit', day: '2-digit' });

                    const user = data.find(({ id }) => id === comment.userId);

                    const userFullName = user ? `${user.firstName} ${user.firstLastName}` : t("ratingsReviewsUserNotFound");

                    return (
                        <>
                            < div className="dashboardView-card clientsDashboardView-ratingsReviews-commentCard " >
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                                    <p style={{ fontWeight: 600 }}>{comment.titleComment}</p>
                                    <Rating readonly item={(props) => customItem({ ...props, showEmptyStars: true })} value={comment.rankValue} style={{ lineHeight: 1, margin: 0 }} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "end", width: "100%" }}>
                                    <p>{formattedDate}</p>
                                    <p>{userFullName}</p>
                                </div>
                                <div style={{ gridColumn: "span 2" }}>
                                    <p> {isExpanded || comment.comment.length <= maxChars ? comment.comment : `${comment.comment.substring(0, maxChars)}...`}
                                        &nbsp;
                                        {comment.comment.length > maxChars && (
                                            <button onClick={toggleReadMore}>
                                                {isExpanded ? t("ratingsReviewsLessText") : t("ratingsReviewsMoreText")}
                                            </button>
                                        )}
                                    </p>
                                </div>
                            </div >
                        </>
                    )
                })
                : (
                    <div style={{ textAlign: "center", padding: "50px", gridColumn: "span 2", fontWeight: "700" }}>
                        <p>{t("noReviewsAvailable")}</p>
                    </div>
                )

            }
        </>
    )
}

export default RatingsReviews